import { defineComponent } from 'vue'

import { AccountResource } from '@sigmacloud/sigma-client/dist/resources'
import AgGridColumnMethodMixins from './AgGridColumnMethods'
import AccountGroupResource from '@/resources/AccountGroupResource'

/*
* AG Grid Column Defs here
*/
export default defineComponent({
  mixins: [AgGridColumnMethodMixins],

  data () {
    return {
      accountCodeColumn: {
        headerName: 'Account #',
        field: 'accountCode',
        colId: 'accountCode',
        maxWidth: 120,
        minWidth: 50,
        editable: true,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          return resource.attributes.code || ''
        },
        valueSetter: () => null
      },
      accountNameColumn: {
        headerName: 'Name',
        field: 'accountName',
        colId: 'accountName',
        maxWidth: 400,
        minWidth: 300,
        editable: true,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          return resource.attributes.name || ''
        },
        valueSetter: () => null
      },
      accountTypeColumn: {
        headerName: 'Type',
        field: 'accountType',
        colId: 'accountType',
        maxWidth: 170,
        minWidth: 100,
        // eslint-disable-next-line
        // editable: () => this.isAccountEditable ? true : false,
        editable: true,
        cellClass: 'editable',
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          return resource.attributes.type || ''
        },
        valueSetter: (params) => {
          if (params.data) params.data.set('type', params.newValue) // This is the important one
          params.data.save()
        },
        cellEditor: 'agRichSelectCellEditor',
        cellEditorParams: {
          values: [ 'HEADER', 'ASSET', 'LIABILITY', 'INCOME', 'EXPENSE_ATL', 'EXPENSE_BTL', 'EXPENSE_POST', 'EXPENSE' ]
        }
      },
      accountParentColumn: {
        headerName: 'Parent',
        field: 'accountParent',
        colId: 'accountParent',
        maxWidth: 400,
        minWidth: 300,
        editable: true,
        sortable: true,
        menuTabs: [],
        valueFormatter: (params) => {
          let resource = params.data
          if (resource && resource.attributes.parent) {
            const cachedParent = AccountResource.getCached(resource.attributes.parent)
            const parentResource = cachedParent.resource
            return parentResource ? parentResource.attributes.name : ''
          }
        },
        valueGetter: (params) => {
          let resource = params.data
          return resource.attributes.parent || ''
        },
        valueSetter: () => null
      },
      accountSummarizedColumn: {
        headerName: 'Summarized',
        field: 'is_summarized',
        colId: 'is_summarized',
        maxWidth: 90,
        minWidth: 90,
        editable: true,
        sortable: true,
        menuTabs: [],
        cellRenderer: (params) => {
          if (!params.data) return null
          const checkbox = document.createElement('input')
          checkbox.type = 'checkbox'
          checkbox.checked = params.data ? params.data.attributes.is_summarized : false
          checkbox.addEventListener('change', () => {
            params.data.changes.is_summarized = checkbox.checked
            this.save()
          })
          return checkbox
        },
        valueGetter: (params) => {
          return params.data.attributes.is_summarized
        }
      },
      accountPostableColumn: {
        headerName: 'Postable',
        field: 'postable',
        colId: 'postable',
        maxWidth: 70,
        minWidth: 70,
        editable: true,
        sortable: true,
        menuTabs: [],
        valueFormatter: (params) => {
          if (params.value === true || params.value === 'true') {
            return 'YES'
          } else {
            return 'NO'
          }
        },
        valueGetter: (params) => {
          let resource = params.data
          return resource.attributes.postable || ''
        },
        valueSetter: () => null
      },

      accountMappingsNetflixColumn: {
        headerName: 'Alternate COA',
        field: 'alternateCoa',
        colId: 'alternateCoa',
        maxWidth: 120,
        minWidth: 70,
        editable: true,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          if (resource && resource.attributes.meta_data && resource.attributes.meta_data.mappings && resource.attributes.meta_data.mappings.netflix && resource.attributes.meta_data.mappings.netflix.code) return resource.attributes.meta_data.mappings.netflix.code
          else {
            return ''
            /* Use this to generate fake data
            if (!resource.attributes.meta_data) resource.attributes.meta_data = {}
            if (!resource.attributes.meta_data.mappings) resource.attributes.meta_data.mappings = {}
            if (!resource.attributes.meta_data.mappings.netflix) resource.attributes.meta_data.mappings.netflix = {}

            const fake = '0' + resource.attributes.code + '0'
            resource.attributes.meta_data.mappings.netflix.code = fake
            return fake
            */
          }
        },
        valueSetter: (params) => {
          let resource = params.data
          if (!resource || !resource.attributes) return
          if (!resource.attributes.meta_data) resource.attributes.meta_data = {}
          if (!resource.attributes.meta_data.mappings) resource.attributes.meta_data.mappings = {}
          if (!resource.attributes.meta_data.mappings.netflix) resource.attributes.meta_data.mappings.netflix = {}
          resource.attributes.meta_data.mappings.netflix.code = params.newValue

          // Bug in sigma-client?
          if (!resource.changes.meta_data) resource.changes.meta_data = resource.attributes.meta_data
        }
      },
      accountMappingsNetflixNameColumn: {
        headerName: 'Alternate Name',
        field: 'alternateName',
        colId: 'alternateName',
        maxWidth: 300,
        minWidth: 100,
        editable: true,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          if (resource && resource.attributes.meta_data && resource.attributes.meta_data.mappings && resource.attributes.meta_data.mappings.netflix && resource.attributes.meta_data.mappings.netflix.name) return resource.attributes.meta_data.mappings.netflix.name
          else {
            // return ''
            /* Use this to generate fake data
            if (!resource.attributes.meta_data) resource.attributes.meta_data = {}
            if (!resource.attributes.meta_data.mappings) resource.attributes.meta_data.mappings = {}
            if (!resource.attributes.meta_data.mappings.netflix) resource.attributes.meta_data.mappings.netflix = {}

            const fake = resource.attributes.name
            resource.attributes.meta_data.mappings.netflix.name = fake
            return fake
            */
          }
        },
        valueSetter: (params) => {
          let resource = params.data
          if (!resource || !resource.attributes) return
          if (!resource.attributes.meta_data) resource.attributes.meta_data = {}
          if (!resource.attributes.meta_data.mappings) resource.attributes.meta_data.mappings = {}
          if (!resource.attributes.meta_data.mappings.netflix) resource.attributes.meta_data.mappings.netflix = {}
          resource.attributes.meta_data.mappings.netflix.name = params.newValue

          // Bug in sigma-client?
          if (!resource.changes || !resource.changes.meta_data) resource.changes.meta_data = resource.attributes.meta_data
          // resource.save()
        }
      },
      accountGroupColumn: {
        headerName: 'Account Group',
        field: 'accountGroup',
        colId: 'accountGroup',
        maxWidth: 90,
        minWidth: 50,
        sortable: false,
        menuTabs: ['columnsMenuTab'],
        // eslint-disable-next-line
        // editable: () => (this.$data.scope.readonly ? false : true),
        editable: true,
        cellClass: 'editable',
        valueGetter: (params) => params && params.data && params.data.attributes.account_group_details ? params.data.attributes.account_group_details.code : '',

        valueFormatter: (params) => params && params.data && params.data.attributes.account_group_details ? params.data.attributes.account_group_details.code : '',
        valueSetter: (params) => {
          params.data.attributes.account_group = params.newValue ? params.newValue.attributes.id : ''
          params.data.attributes.account_group_details = params.newValue ? params.newValue.attributes : ''
        },
        cellEditor: 'gridAutocomplete',
        cellEditorParams: {
          options: {
            resourceClass: AccountGroupResource
            // updateLineResource: true // this effectively replaces valueSetter.  Needed to handle setting data asynchronously.
          }
        }
      }
    }
  }
})
